<div class="logout-page">
  <!-- Left Blue Hero Section -->
  <div class="blue-panel">
    <div class="content-box">
      <h1 class="title">{{ text.title }}</h1>
      <p class="subtitle">
        {{ text.description }}
      </p>
      <button class="btn-signin" (click)="signInAgain()">
        {{ text.loginButton }}
      </button>
    </div>
  </div>

  <!-- Right Graphic Section -->
  <div class="graphic-panel" aria-hidden="true">
    <div class="illustration-container">
      
      <!-- Open Door & Exit Arrow Graphic -->
      <div class="door-graphic">
        <!-- Door Frame Backing -->
        <div class="door-frame"></div>
        
        <!-- Open Door Panel -->
        <div class="door-panel">
          <span class="door-handle"></span>
        </div>
        
        <!-- Blue Exit Arrow -->
        <div class="exit-arrow">
          <svg viewBox="0 0 24 24" fill="currentColor">
            <path d="M5 13h11.86l-5.43 5.43 1.42 1.42L21.71 12 12.85 3.15l-1.42 1.42L16.86 11H5v2z"/>
          </svg>
        </div>
      </div>

      <!-- Session Clock Badge -->
      <div class="clock-badge">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
          <circle cx="12" cy="12" r="9"/>
          <polyline points="9 12 11 14 15 10"/>
        </svg>
      </div>

    </div>
  </div>
</div>